// ----- DO NOT MODIFY THIS FILE DIRECTLY -----
// This file was generated in this project by stack9-cli tool from stack9-instance-template repository.
// If you want to make changes to this file, please edit the template file in the stack9-instance-template repository...
// ...and re-run stack9-cli commands to upgrade your stack9 core components.
//
// For more information about stack9-cli and stack9-instance-template, please visit:
// - stack9-cli: https://github.com/april9au/stack9-cli
// - stack9-instance-template: https://github.com/april9au/stack9-instance-template
// ----- DO NOT MODIFY THIS FILE DIRECTLY -----
//
// Instance-specific configuration belongs in _app.stack9.instance.tsx

import React, { ReactNode, memo } from 'react';
import { AppProvider, AuthProvider } from '@april9au/stack9-react';
import {
  axiosProvider,
  stack9Config,
  UIProvider,
  AppContextProvider,
  App,
  ActionBarComponentProps,
} from '@april9au/stack9-ui';
import { ConfigProvider } from 'antd';

import { stack9CoreModuleComponents } from './_app.core.module';
import {
  stack9StandardModuleRoutes,
  stack9StandardModuleComponents,
} from './_app.standard.modules';

import './_app.css';

/**
 * Base ActionBarComponent — renders defaultActions with no customisation.
 * Export this so _app.stack9.instance.tsx can compose on top of it
 * rather than replacing it from scratch.
 */
export const DefaultActionBarComponent = memo(
  ({ defaultActions }: ActionBarComponentProps) => <>{defaultActions}</>,
);

export interface Stack9FrontendAppExtensions {
  /** Slot for customising the action bar. Defaults to DefaultActionBarComponent. */
  ActionBarComponent?: React.ComponentType<ActionBarComponentProps>;
  /** Any additional UIProvider extension slots. */
  [key: string]: React.ComponentType<any> | undefined;
}

export interface Stack9InstanceConfig {
  /** Additional components to register beyond core + standard modules */
  instanceComponents?: Array<ReactNode>;
  /** Additional custom routes beyond standard module routes */
  instanceRoutes?: Array<{ route: string; component: React.ReactNode }>;
  /**
   * UIProvider extension overrides.
   * Merged on top of built-in defaults (ActionBarComponent → DefaultActionBarComponent).
   */
  extensions?: Stack9FrontendAppExtensions;
}

export function Stack9FrontendAppProvider({
  instanceConfig = {},
}: {
  instanceConfig?: Stack9InstanceConfig;
}) {
  const components = [
    ...stack9CoreModuleComponents,
    ...stack9StandardModuleComponents,
    ...(instanceConfig.instanceComponents ?? []),
  ];

  const customRoutes = [
    ...stack9StandardModuleRoutes,
    ...(instanceConfig.instanceRoutes ?? []),
  ];

  return (
    <AppProvider axiosFactory={axiosProvider} config={stack9Config}>
      <AuthProvider
        clientId="" // backoffice does not require clientId
        onError={err => {
          console.error(err);
        }}
      >
        <UIProvider
          components={components}
          extensions={
            {
              ActionBarComponent: DefaultActionBarComponent,
              ...instanceConfig.extensions,
            } as React.ComponentProps<typeof UIProvider>['extensions']
          }
        >
          <AppContextProvider>
            <ConfigProvider>
              <App customRoutes={customRoutes} />
            </ConfigProvider>
          </AppContextProvider>
        </UIProvider>
      </AuthProvider>
    </AppProvider>
  );
}
